import styled from "styled-components";

export const LiveStreamSlideFooterDefaultBox = styled.div`
    display: flex;
    flex-direction: column;
    bottom: 0;
    padding: 8px 0px 12px 0px;
    align-items: start;
`;